import createTableStore from "ds/components/Table/store/useTableStore";

import {
  TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_CONFIG,
  TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMNS_STORAGE_KEY,
} from "./constants";

const useTemplateDeploymentOutputsTableStore = createTableStore({
  storageKey: TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMNS_STORAGE_KEY,
  config: TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_CONFIG,
});

export default useTemplateDeploymentOutputsTableStore;
